<template>
  <!-- modal cadastro -->
  <b-modal id="modal-associa-resumo" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Associar Resumos a lição</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-associa-resumo')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <template class="modal-body">
      <form v-if="licao.id">
        <h6><i class="fas fa-folder-plus"></i> Adicionar Resumo:</h6><br>
        <h5>Busque seus Resumos:</h5><br>
        <div class="col-12 col-md-12">
          <div class="form-group">
            <div class="input-group mb-3">
              <a href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="searchFile()" ><i class="fas fa-upload"></i>Buscar no meu computador</a>
              <a href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="exibirResumosExistentes = true" ><i class="fas fa-list"></i>Buscar resumo existente</a>
              <b-form-file
                v-model="resumo_selecionado"
                placeholder="Escolha um arquivo"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="image/jpeg, image/png, .pdf"
                ref="inputHidden"
                style="display:none;"
              ></b-form-file>
            </div>
          </div>
        </div>
        <div class="row" v-if="exibirResumosExistentes">
          <div class="col-md-8">
            <div class="form-group">
                <VueSelect v-model="resumoExistenteSelecionado" :options="resumosExistentes" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Selecione um Resumo" label="titulo" track-by="resumo" select-label="Selecionar resumo" deselect-label="Remover resumo" selected-label="Resumo selecionado" :preselect-first="true" :block-keys="['Tab','Enter']">
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span v-if="values.length &amp;&amp; !isOpen">{{ values }} resumos selecionados</span>
                  </template>
                </VueSelect>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <a v-if="resumoExistenteSelecionado" @click="adicionarResumoExistente(resumoExistenteSelecionado)" href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" ><i class="fas fa-plus"></i>Adicionar resumo</a>
            </div>
          </div>
        </div>
        <template v-if="arquivoSelecionado && arquivoSelecionado.length > 0">
          <h6>Resumos Adicionados à esta Lição</h6>
          <div>
            <div class="col-12 col-md-12">
              <div class="form-group">
                <div v-for='(resumo, index) in arquivoSelecionado' v-bind:key='resumo.name'>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                          <input type="text" class="form-control" id="nomeImagem" placeholder="Nome do Resumo" v-model="nomes[index]" />
                      </div>
                      <div class="col-md-6 mb-3 form-control">
                        {{ resumo.name }} <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="removerResumo(resumo)"><i class="fas fa-trash-alt"></i></a>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if='resumosExistentesSelecionados.length > 0'>
          <h6>Resumos Existentes adicionados</h6>
          <div>
            <div class="col-12 col-md-12">
              <div class="form-group" v-if='resumosExistentesSelecionados'>
                <div v-for='resumo in resumosExistentesSelecionados' v-bind:key='resumo.id'>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                          <input type="text" class="form-control" id="nomeImagem" placeholder="Nome do Tópico" v-model="resumo.titulo" disabled/>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="form-control">
                          <a :href="obterUrlS3(resumo.url)" target="_blank" v-if="resumo.url.length > 25">...{{ resumo.url.substr(-25) }}</a>
                          <a :href="obterUrlS3(resumo.url)" target="_blank" v-else>{{ resumo.url.length }}</a>
                          <a class="ml-2" href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirResumoExistente(resumo.id)"><i class="fas fa-trash-alt"></i></a>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if='licao.resumo && licao.resumo.length > 0'>
          <h6>Resumos Existentes nessa Lição</h6>
          <div>
            <div class="col-12 col-md-12">
              <div class="form-group" v-if='licao.resumo'>
                <div v-for='resumo in licao.resumo' v-bind:key='resumo.id'>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                          <input type="text" class="form-control" id="nomeImagem" placeholder="Nome do Tópico" v-model="resumo.titulo" disabled/>
                      </div>
                      <div class="col-md-6 mb-3">
                        <div class="form-control">
                          <a :href="obterUrlS3(resumo.url)" target="_blank" v-if="resumo.url.length > 25">...{{ resumo.url.substr(-25) }}</a>
                          <a :href="obterUrlS3(resumo.url)" target="_blank" v-else>{{ resumo.url.length }}</a>
                          <a class="ml-2" href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirResumo(resumo.id)"><i class="fas fa-trash-alt"></i></a>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="text-center">
          <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
            <button class="btn btn-primary mr-3" type="button" @click="$bvModal.hide('modal-associa-resumo')">Cancelar</button>
            <a href="javascript:void(0)" class="btn btn-secondary" @click="salvarResumo()">Salvar Alterações</a>
          </div>
        </div>
      </form>
      <div class="row" v-else>
        <div class="col-md-12">
          Carregando...
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ResumoAPI from '@/api/resumo-api'
import UrlUtils from '@/core/util/url-utils'
import Swal from 'sweetalert2'
import VueSelect from 'vue-select'
import 'vue-select/src/scss/vue-select.scss'
// import draggable from 'vuedraggable'
import ResponseUtils from '@/core/util/response-utils'
// import { required } from 'vuelidate/lib/validators'
// import FormGroup from '@/core/components/FormGroup'

export default {
  name: 'modalAssociaResumo',
  components: { VueSelect },
  props: {
    licao: Object,
    resumosExistentes: Array
  },
  data () {
    return {
      nomes: [],
      arquivoSelecionado: [],
      resumosExistentesSelecionados: [],
      resumo_selecionado: null,
      resumoExistenteSelecionado: '',
      exibirResumosExistentes: false
    }
  },

  watch: {
    resumo_selecionado: function () {
      if (this.resumo_selecionado) {
        this.removerResumo(this.resumo_selecionado)
        this.arquivoSelecionado.push(this.resumo_selecionado)
      }
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.nomes = []
      this.arquivoSelecionado = []
      this.resumo_selecionado = null
    })
  },

  validations: {},

  methods: {
    adicionarResumoExistente: function (resumo) {
      if (!this.resumosExistentesSelecionados.includes(resumo)) {
        resumo.pdfNovo = true
        this.exibirResumosExistentes = false
        this.resumosExistentesSelecionados.push(resumo)
        this.resumoExistenteSelecionado = ''
      } else {
        Swal.fire({
          title: 'Aviso',
          text: 'O resumo selecionado já foi adicionado a lista'
        })
      }
    },
    obterUrlS3: function (arquivo) {
      if (arquivo.includes('apostila-web') !== false) {
        return UrlUtils.obterUrlS3(arquivo)
      } else {
        return UrlUtils.obterUrlS3('apostila-web/' + arquivo)
      }
    },
    show: function () {
      this.$bvModal.show('modal-associa-resumo')
    },
    removerResumo: function (arquivo) {
      this.arquivoSelecionado = this.arquivoSelecionado.filter((item, index) => {
        if (item.name === arquivo.name) {
          this.nomes.splice(index, 1)
        }
        return item.name !== arquivo.name
      })
    },
    excluirResumoExistente: function (id) {
      this.resumosExistentesSelecionados = this.resumosExistentesSelecionados.filter(item => (
        id !== item.id
      ))
    },
    excluirResumo: function (id) {
      Swal.fire({
        title: 'Você deseja excluir esse resumo?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        const loader = this.$loading.show()
        ResumoAPI.deletar(id).then(data => {
          this.$emit('atualizaLicao')
          loader.hide()
        }).catch(error => ResponseUtils.handleError(error, loader))
      })
    },
    salvarResumo: function () {
      const loader = this.$loading.show()
      console.log(this.licao)
      ResumoAPI.salvar(this.arquivoSelecionado, this.nomes, this.resumosExistentesSelecionados, this.licao.id).then(data => {
        loader.hide()
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Resumos adicionados com sucesso!'
        }).then(() => {
          this.resumosExistentesSelecionados = []
          this.$bvModal.hide('modal-associa-resumo')
          this.$emit('resumosAssociados')
        })
      }).catch(error => ResponseUtils.handleError(error, loader))
    },
    searchFile: function () {
      this.$refs.inputHidden.$el.childNodes[0].click()
    }
  }
}
</script>
